import * as React from 'react';

import {
  formatDateToShortFormat,
  GRAY_STUDENT_HISTORY_BACKGROUND_IMG,
} from '../shared'
import { StudentLearningSequenceActivityInterface, } from '../interfaces'
import GradeColor, { GREEN, ORANGE, RED, } from '../../../modules/grade_color'
import { getTimeSpent, } from '../../../../helpers/studentReports'

interface IndividualStudentPracticeCardProps {
  studentLearningSequenceId: number;
  preOrPost: string;
  activities?: StudentLearningSequenceActivityInterface[];
  relevantDiagnostic?: StudentLearningSequenceActivityInterface;
}

const IndividualStudentPracticeCard = ({ activities, relevantDiagnostic, studentLearningSequenceId, preOrPost, }: IndividualStudentPracticeCardProps) => {
  const activityCount = activities?.percentages?.length || 0
  const fullProficiencyInEverySkill = relevantDiagnostic?.skill_performance?.every(skill => skill.questions_total === skill.questions_correct)

  let completionText = fullProficiencyInEverySkill ? 'N/A' : 'None completed'
  let performanceCopy: JSX.Element|string = fullProficiencyInEverySkill ? 'N/A' : '—'
  let practiceCopy: JSX.Element|string = fullProficiencyInEverySkill ? 'No practice was recommended as full proficiency was demonstrated in all skills.' : '—'
  let greenActivityCount = 0
  let orangeActivityCount = 0
  let redActivityCount = 0

  if (activityCount) {
    completionText = formatDateToShortFormat(activities.earliest)

    if (activityCount > 1) {
      completionText += ` — ${formatDateToShortFormat(activities.latest)}`
    }

    greenActivityCount = activities.percentages.filter(percentage => GradeColor(percentage) === GREEN)?.length || 0
    orangeActivityCount = activities.percentages.filter(percentage => GradeColor(percentage) === ORANGE)?.length || 0
    redActivityCount = activities.percentages.filter(percentage => GradeColor(percentage) === RED)?.length || 0

    performanceCopy = <React.Fragment>Scored green on {Math.round((greenActivityCount/activityCount) * 100)}% of activities</React.Fragment>

    practiceCopy = (
      <React.Fragment>
        <span>Activities completed: {activityCount}</span>
        <span>Time spent: {getTimeSpent(activities.timespent)}</span>
      </React.Fragment>
    )
  }

  const headerId = `studentLearningSequence${studentLearningSequenceId}${preOrPost}PracticeCardHeader`

  return (
    <section aria-labelledby={headerId} className="student-learning-sequence-card practice-card">
      {GRAY_STUDENT_HISTORY_BACKGROUND_IMG}
      <div className="card-content">
        <h5 id={headerId}>Practice</h5>
        <span className="completion">{completionText}</span>
        <div className="details">
          <div className="performance-and-practice">
            <h6>Performance</h6>
            {performanceCopy}
            <h6>Practice</h6>
            {practiceCopy}
          </div>
          {(activityCount || !fullProficiencyInEverySkill) && (
            <div className="score-boxes">
              <div aria-label={`Frequently demonstrated skill on ${greenActivityCount} practice activities`} className="score-box green">{greenActivityCount}</div>
              <div aria-label={`Sometimes demonstrated skill on ${orangeActivityCount} practice activities`} className="score-box orange">{orangeActivityCount}</div>
              <div aria-label={`Rarely demonstrated skill on ${redActivityCount} practice activities`} className="score-box red">{redActivityCount}</div>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default IndividualStudentPracticeCard
